import React from "react";
import {
  Grid,
  Container,
  Card,
  Typography,
} from "@material-ui/core";
import { TyCStyles } from "./TyCStyles";
import { useTranslation } from "react-i18next";

export function PrivacyPolicyTyC(props) {
  const classes = TyCStyles();
  const { t, i18n } = useTranslation();

  return (
    <Grid
      className={
        !props.showSideMenu ? classes.container : classes.hideContainer
      }
    >
      <Container maxWidth={"lg"} className={classes.mainContainer}>
        <Card className={classes.cardContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography align="justify" className={classes.text}>
                <div id="Top" />
                <p>{t("privacyPolicyText00_01a")}<b><a href="https://identidad.correos.es/" className={classes.links} target="_blank" rel="noopener noreferrer">{t("privacyPolicyText00_01b")}</a></b>{t("privacyPolicyText00_01c")}</p>
                <ol>
                  <li>
                    <h5 className={classes.subtitles}>
                      {t("privacyPolicyTitle01")}
                    </h5>
                    <p>{t("privacyPolicyText01_01")}</p>
                    <p>{t("privacyPolicyText01_02a")}<b><a href="mailto:dpdgrupocorreos@correos.com" className={classes.links} target="_blank" rel="noopener noreferrer">dpdgrupocorreos@correos.com</a></b></p>
                  </li>
                  <li>
                    <h5 className={classes.subtitles}>
                      {t("privacyPolicyTitle02")}
                    </h5>
                    <p>{t("privacyPolicyText02_01")}</p>
                    <ol type="A">
                      <li>
                        <p><b>{t("privacyPolicyText02_02")}</b></p>
                      </li>
                      <p><b>{t("privacyPolicyText02_03a")}</b>{t("privacyPolicyText02_03b")}</p>
                      <p><b>{t("privacyPolicyText02_04a")}</b>{t("privacyPolicyText02_04b")}</p>
                      <p><b>{t("privacyPolicyText02_05a")}</b>{t("privacyPolicyText02_05b")}</p>
                      <li>
                        <p><b>{t("privacyPolicyText02_06")}</b></p>
                      </li>
                      <p>{t("privacyPolicyText02_07a")}<b><a href="https://identidad.correos.es/TyC/Pol%C3%ADticaDeCookies" className={classes.links} target="_blank" rel="noopener noreferrer">{t("privacyPolicyText02_07b")}</a></b></p>
                    </ol>
                  </li>
                  <li>
                    <h5 className={classes.subtitles}>
                      {t("privacyPolicyTitle03")}
                    </h5>
                    <p>{t("privacyPolicyText03_01")}</p>
                    <ol type="a">
                      <li>
                        <p><b>{t("privacyPolicyText03_02a")}</b>{t("privacyPolicyText03_02b")}<b><a href="https://identidad.correos.es/TyC/Pol%C3%ADticaDeCookies" className={classes.links} target="_blank" rel="noopener noreferrer">{t("privacyPolicyText03_02c")}</a></b></p>
                      </li>
                      <li>
                        <p><b>{t("privacyPolicyText03_03a")}</b>{t("privacyPolicyText03_03b")}</p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <h5 className={classes.subtitles}>
                      {t("privacyPolicyTitle04")}
                    </h5>
                    <p>{t("privacyPolicyText04_01")}</p>
                  </li>
                  <li>
                    <h5 className={classes.subtitles}>
                      {t("privacyPolicyTitle05")}
                    </h5>
                    <p>{t("privacyPolicyText05_01a")}<b><a href="https://identidad.correos.es/TyC/Pol%C3%ADticaDeCookies" className={classes.links} target="_blank" rel="noopener noreferrer">{t("privacyPolicyText05_01b")}</a></b></p>
                  </li>
                  <li>
                  <h5 className={classes.subtitles}>
                      {t("privacyPolicyTitle06")}
                    </h5>
                    <p>{t("privacyPolicyText06_01")}</p>
                    <p>{t("privacyPolicyText06_02")}</p>
                  </li>
                  <li>
                  <h5 className={classes.subtitles}>
                      {t("privacyPolicyTitle07")}
                    </h5>
                    <p>{t("privacyPolicyText07_01a")}<b><a href="mailto:derechos.protecciondatos.correos@correos.com" className={classes.links} target="_blank" rel="noopener noreferrer">derechos.protecciondatos.correos@correos.com</a></b></p>
                    <p>{t("privacyPolicyText07_02")}</p>
                    <p>{t("privacyPolicyText07_03")}</p>
                  </li>
                </ol>
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </Grid>
  );
}
